export const expertise = [
  {
    title: "Interfaces",
    items:
      "JavaScript, React, Vue.js, Next.js, Tailwind CSS, TypeScript, HTML & CSS",
  },
  {
    title: "Systems & APIs",
    items: "Laravel, PHP, Node.js, Django, REST APIs, Medusa.js SDK",
  },
  {
    title: "Data & interaction",
    items: "TanStack Query, Redux Toolkit, React Hook Form, Zod",
  },
  {
    title: "Design to delivery",
    items: "shadcn/ui, Figma, Git, GitHub, Postman, Vercel",
  },
];
